const ghost: object = {
  transparent: {
    backgroud: "bg-transparent",
    color: "text-blue-gray-900",
  },
  white: {
    color: "text-white",
    background: "bg-white/10",
  },
  "blue-gray": {
    color: "text-blue-gray-500",
    background: "bg-blue-gray-500/10",
  },
  gray: {
    color: "text-gray-900",
    background: "bg-gray-900/10",
  },
  brown: {
    color: "text-brown-500",
    background: "bg-brown-500/10",
  },
  "deep-orange": {
    color: "text-deep-orange-500",
    background: "bg-deep-orange-500/10",
  },
  orange: {
    color: "text-orange-500",
    background: "bg-orange-500/10",
  },
  amber: {
    color: "text-amber-500",
    background: "bg-amber-500/10",
  },
  yellow: {
    color: "text-yellow-500",
    background: "bg-yellow-500/10",
  },
  lime: {
    color: "text-lime-500",
    background: "bg-lime-500/10",
  },
  "light-green": {
    color: "text-light-green-500",
    background: "bg-light-green-500/10",
  },
  green: {
    color: "text-green-500",
    background: "bg-green-500/10",
  },
  teal: {
    color: "text-teal-500",
    background: "bg-teal-500/10",
  },
  cyan: {
    color: "text-cyan-500",
    background: "bg-cyan-500/10",
  },
  "light-blue": {
    color: "text-light-blue-500",
    background: "bg-light-blue-500/10",
  },
  blue: {
    color: "text-blue-500",
    background: "bg-blue-500/10",
  },
  indigo: {
    color: "text-indigo-500",
    background: "bg-indigo-500/10",
  },
  "deep-purple": {
    color: "text-deep-purple-500",
    background: "bg-deep-purple-500/10",
  },
  purple: {
    color: "text-purple-500",
    background: "bg-purple-500/10",
  },
  pink: {
    color: "text-pink-500",
    background: "bg-pink-500/10",
  },
  red: {
    color: "text-red-500",
    background: "bg-red-500/10",
  },
};

export default ghost;
